// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3NFig","label":"styles_label__1rSbw","select":"styles_select__2R2d3","error":"styles_error__2iicP"};